<a #heart id="{{'location-' + id}}" (click)="favoriteService.toggleFavorite(id, locationType)" class="btn-favorite" data-school="school-1">
    <i [ngClass]="{'icon-heart-empty': !favoriteService.isFavorite(id), 'icon-heart': favoriteService.isFavorite(id)}"></i>
</a>
